import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  getAuthTokenFromLocalStorage,
  getAuthUserFromLocalStorage,
} from '../../helper';
import { APIDataProvider, TApiResponse, AdminApiPaths } from '../../api';

const apiDataProvider = new APIDataProvider();

// eslint-disable-next-line import/prefer-default-export
export const generateQuestion = createAsyncThunk(
  'admin/gpt/question',
  async (data: any) => {
    const response = await apiDataProvider.post<TApiResponse<any>>(
      `${AdminApiPaths.gpt}/question`,
      data
    );

    return response.data;
  }
);

export const generateQuestionStream = async (
  formData: FormData,
  onQuestion: (question: any) => void,
  onComplete: (threadId: string, totalQuestions: number) => void,
  onError: (error: string) => void
): Promise<void> => {
  const token = getAuthTokenFromLocalStorage();
  const authUser = getAuthUserFromLocalStorage();
  const baseURL = process.env.REACT_APP_TUTOPIYA_BASE_URL_V2;

  const headers: Record<string, string> = {};
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }
  if (authUser) {
    headers['user-id'] = authUser._id;
  }

  try {
    const response = await fetch(
      `${baseURL}${AdminApiPaths.gpt}/question/stream`,
      {
        method: 'POST',
        headers,
        body: formData,
      }
    );

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const reader = response.body?.getReader();
    const decoder = new TextDecoder();

    if (!reader) {
      throw new Error('No response body');
    }

    let buffer = '';

    try {
      while (true) {
        // eslint-disable-next-line no-await-in-loop
        const { done, value } = await reader.read();

        if (done) {
          break;
        }

        buffer += decoder.decode(value, { stream: true });
        const lines = buffer.split('\n');
        buffer = lines.pop() || '';

        // eslint-disable-next-line no-restricted-syntax
        for (const line of lines) {
          if (line.startsWith('data: ')) {
            const data = line.slice(6);
            if (data.trim()) {
              try {
                const parsed = JSON.parse(data);

                if (parsed.type === 'question') {
                  onQuestion(parsed.question);
                } else if (parsed.type === 'completed') {
                  onComplete(parsed.threadId, parsed.totalQuestions);
                  return;
                } else if (parsed.type === 'error') {
                  onError(parsed.error || 'An error occurred');
                  return;
                } else if (parsed.type === 'connected') {
                  // Connection established
                }
              } catch (e) {
                console.error('Error parsing SSE data:', e);
              }
            }
          }
        }
      }
    } catch (error: any) {
      onError(error?.message || 'Stream reading error');
    }
  } catch (error: any) {
    onError(error?.message || 'Failed to start stream');
  }
};
